import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classicActionRequest } from '@/lib/classic-admin-api';
import { ClassicItemIcon } from '@/components/GameIcon';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ClassicCategoryBadge, ClassicItemPicker, type ClassicRewardItem } from './ClassicItemPicker';
export interface Reward { id: string; amount: number; name?: string; itemCategory?: number | string }
export function ClassicRewardEditor({ value, onChange, disabled = false }: {
  value: Reward[]; onChange: (value: Reward[]) => void; disabled?: boolean;
}) {
  const [selected, setSelected] = useState('');
  const [amount, setAmount] = useState(1);
  const catalog = useQuery({ queryKey: ['classic', 'liveops', 'catalog'], queryFn: ({ signal }) => classicActionRequest<{items: ClassicRewardItem[]}>('/liveops/catalog', signal) });
  const items = catalog.data?.items ?? [];
  const item = items.find(item => item.id === selected);
  const available = items.filter(item => !value.some(reward => reward.id === item.id));
  return <fieldset disabled={disabled} className="space-y-3 rounded-lg border p-3"><legend className="px-1 text-sm">Rewards</legend>
    {value.map((reward, index) => {
      const definition = items.find(item => item.id === reward.id);
      return <div key={reward.id} className="flex flex-wrap items-center gap-2">
        <ClassicItemIcon id={reward.id.startsWith('costume_') ? 'costume' : reward.id} />
        <span className="min-w-0 flex-1">{definition?.name ?? reward.name ?? reward.id} × {reward.amount.toLocaleString()}</span>
        <ClassicCategoryBadge item={definition ?? {id: reward.id, itemCategory: Number(reward.itemCategory)}} />
        <Button type="button" variant="outline" onClick={() => onChange(value.filter((_, i) => i !== index))}>Remove</Button>
      </div>;
    })}
    {catalog.error && <p role="alert">{catalog.error.message} <Button type="button" variant="outline" onClick={() => void catalog.refetch()}>Retry</Button></p>}
    <div className="flex flex-wrap gap-2">
      <ClassicItemPicker value={selected} items={available} disabled={disabled} loading={catalog.isPending} onChange={id => { setSelected(id); setAmount(1); }} />
      <Input className="w-24" aria-label="Reward amount" type="number" min={1} max={item?.maxAmount ?? 1} value={amount} onChange={event => setAmount(Number(event.target.value))} />
      <Button type="button" disabled={!item || value.some(reward => reward.id === item.id) || !Number.isSafeInteger(amount) || amount < 1 || amount > item.maxAmount || value.length >= 100} onClick={() => {
        if (!item) return;
        onChange([...value, {id: item.id, name: item.name, amount, ...(item.itemCategory ? {itemCategory: item.itemCategory} : {})}]);
        setSelected(''); setAmount(1);
      }}>Add reward</Button>
    </div>
  </fieldset>;
}
